export enum FamilyGroupCode {
  corn = 'CORN',
  soybeans = 'SOYBEANS',
  wheat = 'WHEAT',
  otherCrop = 'OTHERCROP',
  promo = 'PROMO',
  nonCrop = 'NONCROP',
}

export enum FamilyCode {
  balance_forward = 'BALFWD',
  better_bedding = 'BBEDDING',
  bulk_soybeans = 'BLK SOY',
  bulk_wheat = 'BLK WHT',
  bonus_transfer = 'BONXFER',
  cattle = 'CATTLE',
  commercial_soybeans = 'CBEAN',
  commercial_corn = 'CCORN',
  cash_discount_carry_over = 'CD CARRY',
  contingent_income = 'CONTINC',
  corn = 'CORN',
  cover_crop = 'COV CROP',
  cr_memo_ap_adjust = 'CR MEMO',
  crop_health_image = 'CROP IMG',
  commercial_wheat = 'CWHEAT',
  discard_soybeans = 'DCDBEANS',
  discard_corn = 'DCDCORN',
  discard_wheat = 'DCDWHEAT',
  alfalfa = 'EL ALF',
  expense = 'EXPENSE',
  forages = 'FORAGES',
  farm_prods = 'FRM PRDS',
  government_no_charge_oats = 'GVNC OAT',
  inbred = 'INBRED',
  seed_inoculants = 'INOCS',
  interest_income = 'INTINC',
  merchandise_for_resale = 'MERCHINC',
  milo = 'MILO',
  misc = 'MISC',
  non_cd_adjustment = 'NOCDADJ',
  non_retail_seed = 'NRETSEED',
  non_tax_interest_income = 'NTINTINC',
  oats_and_small_grains = 'OATS SG',
  other_income = 'OTHINC',
  other_income_extended_terms = 'OTHINCXT',
  packing = 'PACKAGE',
  planter_box_treatment = 'PLR BOX',
  planter_plates = 'PNR PLTS',
  promo = 'PROMO',
  refuns = 'REFUNDS',
  rental_income = 'RENTINC',
  research_income = 'Research',
  sales_tax = 'SALESTAX',
  shared_account = 'SHARED',
  shuck_bales = 'SHCKBALE',
  silage_inoculants = 'SILINOCS',
  sales_aids = 'SLS AIDS',
  soybeans = 'SOYBEANS',
  sweet_corn = 'SWTCORN',
  technology = 'TECH',
  corn_test_plot = 'TP Corn',
  total_acres = 'ToTAcres',
  wholesale_corn = 'WH CORN',
  wholesale_soybean = 'WH SOY',
  wholesale_wheat = 'WH WHT',
  wheat = 'WHEAT',
}

export enum FamilyID {
  Corn = 1,
  Soybeans = 2,
  Wheat = 3,
  OatsAndSmallGrains = 4,
  Milo = 6,
  Alfalfa = 7,
  CoverCrop = 8,
  Forages = 9,
  SeedInoculants = 15,
  SweetCorn = 19,
  SilageInoculants = 25,
  Merchinc = 45,
  Promo = 75,
}

export const FamilyIdMapping = {
  [FamilyID.Corn]: FamilyCode.corn,
  [FamilyID.Soybeans]: FamilyCode.soybeans,
  [FamilyID.Wheat]: FamilyCode.wheat,
  [FamilyID.OatsAndSmallGrains]: FamilyCode.oats_and_small_grains,
  [FamilyID.Milo]: FamilyCode.milo,
  [FamilyID.Alfalfa]: FamilyCode.alfalfa,
  [FamilyID.CoverCrop]: FamilyCode.cover_crop,
  [FamilyID.Forages]: FamilyCode.forages,
  [FamilyID.SilageInoculants]: FamilyCode.silage_inoculants,
  [FamilyID.Merchinc]: FamilyCode.merchandise_for_resale,
  [FamilyID.Promo]: FamilyCode.promo,
};

export const NonReturnableFamilies: number[] = [FamilyID.SeedInoculants, FamilyID.SweetCorn, FamilyID.SilageInoculants];
